import React, {
  memo, useState, useRef, useEffect, useCallback,
} from 'react';
import { FormattedMessage } from 'react-intl';
// images
import PdfIcon from 'assets/icons/icon-pdf-on.png';
import PlusIcon from 'assets/icons/plus.svg';
// style
import './ButtonUpload.scss';
import replace from 'assets/icons/icon-replace.svg';
import pngIcon from 'assets/icons/img-icon-off.svg';
import classNames from 'classnames';

interface Props {
  label: string,
  hasContainer?: boolean,
  isFileUploaded?: boolean,
  downLoadFileFunct?: any,
  labelUploaded:string
  onButtonClick?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined,
  isDisabled?:boolean
  accept?:string,
  // fileIcon?:any,
  fileType?:string,
  isUploadHidden?: boolean
}

const ButtonUpload: React.FC<Props> = memo(({
  onButtonClick, label, labelUploaded, isFileUploaded, downLoadFileFunct, isDisabled = false,
  accept = 'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf',
  // fileIcon = PdfIcon,
  fileType, isUploadHidden = false,
}) => {
  const [isUploaded, setIsUploaded] = useState(isFileUploaded);
  const [labelMsg, setLabelMsg] = useState(isFileUploaded ? label : labelUploaded);
  const [icon, setIcon] = useState(isFileUploaded ? label : labelUploaded);

  const fileInput = useRef(null);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!accept.includes(file.type)) {
      return;
    }

    if (file.type === 'application/pdf') {
      setIcon(PdfIcon);
    } else {
      setIcon(pngIcon);
    }

    if (file) {
      onButtonClick(file);
      setLabelMsg(label);
      setIsUploaded(true);
    }
  };

  const replaceFile = (e) => {
    e.stopPropagation();
    fileInput.current.click();
  };

  useEffect(() => {
    setIsUploaded(isFileUploaded);
    setLabelMsg(isFileUploaded ? label : labelUploaded);
  }, [isFileUploaded, label, labelUploaded]);

  const handleButtonClick = () => {
    if (isUploaded) {
      downLoadFileFunct();
    } else {
      fileInput.current.click();
    }
  };

  const getFileType = useCallback(() => {
    switch (fileType) {
      case 'img':
        return pngIcon;
      default:
        return PdfIcon;
    }
  }, [fileType]);

  useEffect(() => {
    if (fileType) {
      setIcon(getFileType());
    }
  }, [fileType, getFileType, setIcon]);

  const classes = classNames({
    buttonUpload: true,
    disabled: isDisabled,
    uploaded: isUploaded,
    img: icon === pngIcon,
  });

  return (
    <>
      <button type="button" className={classes} onClick={handleButtonClick}>
        <span className="buttonUpload__image"><img src={isUploaded ? getFileType() : PlusIcon} alt="icon plus" /></span>
        <span className="buttonUpload__label">
          <FormattedMessage
            id={labelMsg}
            values={{
              small: (...chunks) => <small>{chunks}</small>,
            }}
          />
        </span>

        {!isUploadHidden ? (
          isUploaded && <img alt="" src={replace} className="buttonUpload--replace" onClick={replaceFile} />
        ) : null}

      </button>
      <input
        disabled={isDisabled}
        type="file"
        ref={fileInput}
        onChange={(e) => handleChange(e)}
        className="buttonUpload__input"
      />
    </>
  );
});

ButtonUpload.defaultProps = {
  onButtonClick: () => {},
};

export default ButtonUpload;
